export default ($resource) => {
    const base = `${SEED_CORE.ENV.API_URL}skill/skill-scale`;
    const withId = `${base}/:id`;

    return $resource(withId, { id: '@id' }, {
        query: { method: 'GET', url: base, isArray: true },
        get: { method: 'GET', url: withId, isArray: false },
        save: { method: 'POST', url: base },
        update: { method: 'PUT', url: withId },
        delete: { method: 'DELETE', url: withId }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/SkillScale/index.js